export const textFromHtml = source => source?.replace(/<.*?>/g, '') ?? ''
